<template>
    <div>
        <Form
            ref="observer"
            v-slot="{ meta }"
            @submit="handleSubmit"
        >
            <v-form @submit.prevent="handleSubmit">
                <slot :invalid="!meta.valid"></slot>
                <div style="display: flex; justify-content: center" class="mt-2" v-if="useDefaultBtn">
                    <app-btn
                        :color="!meta.valid ? '#757575' : 'primary'"
                        type="submit"
                        class="mb-4"
                        :disabled="!meta.valid"
                        :loading="saving"
                    >
                        {{ submitButtonTitle }}
                    </app-btn>
                    <app-btn v-if="cancelable" color="primary" class="ml-2" outlined @click="$emit('cancel')">Cancel</app-btn>
                </div>
            </v-form>
        </Form>
    </div>


</template>

<script>

import { Form } from 'vee-validate'

export default {
    props: {
        submitButtonTitle: {
            type: String,
            default: 'Save'
        },
        saving: {
            type: Boolean
        },
        cancelable: {
            type: Boolean,
        },
        useDefaultBtn: {
            type: Boolean,
            default: true
        }
    },
    name: "AppForm",
    components: {
        Form
    },
    data() {
        return {
            lastName: ''
        }
    },
    methods: {
        handleSubmit() {
            this.$emit('submit');
        },
    }
}
</script>

<style scoped>
.v-card {
    border-radius: 0!important;
}
</style>
